import React, { useEffect, useState } from "react";
import AnalyseModal from "../../../modals/AnalyseModal";
import PositionsInfo from "./PositionsInfo";
import ExitIcon from "../../../images/icons/exit.svg";
import ExitDark from "../../../images/icons/export.svg";
import EmptyPositions from "./EmptyPositions";
import ShimmerPositionsTable from "./PositionsTableSkeleton";
import { useTheme } from "../../../context/ThemeContext";
import PositionsTable from "../components/PositionsTable";
const ExecutedStrategiesView = ({
  strategyBased,
  symbolData,
  handleClick,
  isExitSelectedEnabledExecutedStrategies,
  modalData,
  symbols,
  handleCallback,
  showToast,
  isFetching,
  hadPositions,
  handleRowMouseEnter,
  handleRowMouseLeave,
  hoveredRowIndex,
  mainIndex,
  visibility,
  handleAddModal,
  handleExitModal,
  handleCheckboxChange,
  formatNumberWithFontWeight,
}) => {
  const theme = useTheme();
  const [expandedBlocks, setExpandedBlocks] = useState({});
  const [isAnalyseModalOpen, setIsAnalyseModalOpen] = useState(false);
  const [selectedAnalyseData, setSelectedAnalyseData] = useState(null);
  const hasNonZeroQuantity = (positions) => {
    return positions.some((position) => position.net_quantity !== 0);
  };

  useEffect(() => {
    if (strategyBased && strategyBased.length > 0) {
      const initialExpandedState = {};
      strategyBased.forEach((_, index) => {
        initialExpandedState[index] = true;
      });
      setExpandedBlocks(initialExpandedState);
    }
  }, [strategyBased]);

  const toggleExpand = (index) => {
    setExpandedBlocks((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleAnalyseClick = (data) => {
    setSelectedAnalyseData(data);
    setIsAnalyseModalOpen(true);
    handleClick(data);
  };

  const handleAnalyseModalClose = () => {
    setIsAnalyseModalOpen(false);
    setSelectedAnalyseData(null);
    handleCallback();
  };

  if (!strategyBased || strategyBased.length === 0) {
    // show skeleton during refresh if positions previously existed
    if (isFetching && hadPositions) {
      return (
        <div className="group-table flex flex-col gap-3 w-full">
          <div className="group-container w-full">
            <ShimmerPositionsTable />
          </div>
        </div>
      );
    }
    return <EmptyPositions />;
  }
  return (
    <>
      {strategyBased &&
        strategyBased.map((data, index) => {
          let groupNetProfit = 0;
          data?.positions?.map((position) => {
            let ltp = symbolData[position?.code]?.ltp;
            if (ltp) {
              let pnl =
                parseFloat(position?.realised_pl) +
                (parseFloat(ltp) - parseFloat(position?.average_prc)) *
                parseFloat(position?.net_quantity);
              groupNetProfit = groupNetProfit + pnl;
            }
            return null;
          });

          const isExpanded = expandedBlocks[index] === true;
          const hasValidPositions = hasNonZeroQuantity(data.positions);
          return (
            <div className="group-table flex flex-col gap-3 w-full" key={index}>
              <div className="group-container w-full">
                <div className="border-0 flex flex-col p-4 gap-3 w-full">
                  <div className="flex items-center justify-between">
                    <div className="symbol-info flex flex-col">
                      <div className="text-lg font-semibold text-p300">
                        {data?.scrip}{" "}
                        <span className="text-md font-medium text-n600 ml-2">
                          ({data?.strategy})
                        </span>
                      </div>
                    </div>

                    <div className="flex gap-3 items-center">
                      <button
                        onClick={() => handleAnalyseClick(data)}
                        className={`bg-swipe-button w-24 h-7 rounded-md flex justify-center items-center gap-2 text-p400 text-xs font-semibold ${hasValidPositions
                            ? "enabled"
                            : "disabled opacity-50 cursor-not-allowed"
                          }`}
                        disabled={!hasValidPositions}>
                        {theme === "dark" ? (
                          <img src={ExitDark} alt="" />
                        ) : (
                          <img src={ExitIcon} alt="" />
                        )}
                        Analyse
                      </button>
                      <button
                        className={`w-14 h-7 rounded-md flex justify-center items-center gap-2 text-xs font-semibold ${isExitSelectedEnabledExecutedStrategies[index]
                            ? "bg-p300 text-p400"
                            : "bg-n300 text-p400"
                          }`}
                        onClick={() => showToast("executedstrategies", index)}
                        disabled={
                          !isExitSelectedEnabledExecutedStrategies[index]
                        }>
                        Exit
                      </button>
                    </div>
                  </div>
                </div>

                {/* Show positions table and info only when expanded */}
                {isExpanded && (
                  <>
                    <PositionsTable
                      positions={data.positions}
                      symbolData={symbolData}
                      handleRowMouseEnter={handleRowMouseEnter}
                      handleRowMouseLeave={handleRowMouseLeave}
                      handleCheckboxChange={handleCheckboxChange}
                      hoveredRowIndex={hoveredRowIndex}
                      mainIndex={index}
                      activeButton="executedstrategies"
                      visibility={visibility}
                      handleAddModal={handleAddModal}
                      handleExitModal={handleExitModal}
                      formatNumberWithFontWeight={formatNumberWithFontWeight}
                    />
                  </>
                )}
                <PositionsInfo data={data} groupNetProfit={groupNetProfit} />

                <div className="flex justify-center mt-2 mb-2">
                  <button
                    className="expand-collapse-btn"
                    onClick={() => toggleExpand(index)}>
                    {isExpanded ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-chevron-up-icon lucide-chevron-up">
                        <path d="m18 15-6-6-6 6" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-chevron-down-icon lucide-chevron-down">
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      {/* Analyse Modal */}
      {isAnalyseModalOpen && selectedAnalyseData && (
        <AnalyseModal
          isOpen={isAnalyseModalOpen}
          onClose={handleAnalyseModalClose}
          data={selectedAnalyseData?.computedData}
          selectedData={selectedAnalyseData?.positions}
          selectedSymbol={
            symbols?.filter(
              (option) => option.scrip === selectedAnalyseData?.scrip
            )[0]
          }
          type="symbol"
          index={strategyBased.findIndex(
            (item) => item === selectedAnalyseData
          )}
          allOptionData={selectedAnalyseData?.allOptionData}
          closeCallBack={handleAnalyseModalClose}
        />
      )}
    </>
  );
};

export default ExecutedStrategiesView;
